module.exports = __webpack_public_path__ + "img/nacimientos-yaara-thumbnail.4d5fda00.jpg";